import { render, staticRenderFns } from "./UserCoupon.vue?vue&type=template&id=0037c8c3&scoped=true"
import script from "./UserCoupon.vue?vue&type=script&lang=js"
export * from "./UserCoupon.vue?vue&type=script&lang=js"
import style0 from "./UserCoupon.vue?vue&type=style&index=0&id=0037c8c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0037c8c3",
  null
  
)

export default component.exports